import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import 'react-datepicker/dist/react-datepicker.css';
import { useTheme } from "@mui/material/styles";

const CustomDatePicker = ({ selectedDate, handleDateChange, isDocEditable, label }) => {
  const theme = useTheme();

  useEffect(() => {
    const datePickerWrappers = document.querySelectorAll('.react-datepicker-wrapper');
    datePickerWrappers.forEach(wrapper => {
      wrapper.style.width = '100%';
    });
  }, []);

  return (
    <div style={{ width: '100%', pointerEvents: isDocEditable ? 'auto' : 'none' }}>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="dd-MM-yyyy"
        placeholderText="DD-MM-YYYY"
        showPopperArrow={false}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        customInput={
          <TextField
            label={label}
            fullWidth
            variant="outlined"
            sx={{
              width: '100%',
              backgroundColor: theme.palette.background.paper,
              '& .MuiOutlinedInput-root': {
                '&.Mui-disabled': {
                  backgroundColor: theme.palette.mode === "dark"
                    ? theme.palette.primary.dark
                    : theme.palette.primary.main,
                  opacity: 1,
                },
              },
            }}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarMonthIcon style={{ color: '#666', cursor: isDocEditable ? 'pointer' : 'default' }} />
                </InputAdornment>
              ),
            }}
          />
        }
        wrapperClassName="custom-datepicker-wrapper"
      />
    </div>
  );
};

export default CustomDatePicker;
